import React, { Component } from "react";
import { Checkbox } from "antd";

export class PermissionArea extends Component {
  handleChangePermissionArea = (checkedIndex) => {
    const { onChange, value } = this.props;

    if (value != checkedIndex) {
      onChange(checkedIndex);
    } else {
      onChange(null);
    }
  };

  render() {
    const { value, editable, typeOption } = this.props;

    return (
      <div className="department">
        <Checkbox
          disabled={!editable}
          onChange={() => this.handleChangePermissionArea(1)}
          checked={value === 1}
        >
          Hà Nội
        </Checkbox>
        <Checkbox
          disabled={!editable}
          onChange={() => this.handleChangePermissionArea(2)}
          checked={value === 2}
        >
          Đà Nẵng
        </Checkbox>
        <Checkbox
          disabled={!editable}
          onChange={() => this.handleChangePermissionArea(3)}
          checked={value === 3}
        >
          Hồ Chí Minh
        </Checkbox>
      </div>
    );
  }
}
